// Types para los comprobantes del modulo contable (independientes de authorizedVouchers)
export const CONTABLE_COMPROBANTES_REQUEST = 'CONTABLE_COMPROBANTES_REQUEST';
export const CONTABLE_COMPROBANTES_SUCCESS = 'CONTABLE_COMPROBANTES_SUCCESS';
export const CONTABLE_COMPROBANTES_ERROR   = 'CONTABLE_COMPROBANTES_ERROR';
export const CONTABLE_COMPROBANTES_CLEAR   = 'CONTABLE_COMPROBANTES_CLEAR';
